<template>
  <v-app>

    <v-app-bar app color="white">
      <v-container>
        <v-row>
          <div class="d-flex align-center">
            <v-img alt="Fundtastic Logo" class="shrink mr-2" contain src="https://assets.invisee.com/statis/logo.png"
              transition="scale-transition" />
          </div>
          <v-spacer></v-spacer>


          <v-menu bottom left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn light icon v-bind="attrs" v-on="on" class="d-flex d-sm-none">
                <v-icon>mdi-menu</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item v-for="(item, i) in items" :key="i">
                <v-list-item-title @click="$vuetify.goTo(item.anchor)" class="listitemmenu">{{ item.title }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-list-item-title @click="comingsoon()" class="listitemmenu">Due Diligence
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <div class="d-none d-sm-flex">
            <v-btn text @click="$vuetify.goTo('#product')">
              Product
            </v-btn>
            <v-btn text @click="$vuetify.goTo('#client')">
              Client
            </v-btn>
            <v-btn text @click="$vuetify.goTo('#contact')">
              Contact </v-btn>
            <v-btn text @click="comingsoon()">
              Due Diligence </v-btn>
          </div>
        </v-row>
      </v-container>
    </v-app-bar>

    <v-main>
      <HeaderImage />
      <ValueProporsition id="value" />
      <SolvingProblem id="solving" />
      <EmpoweringCustomer id="product" />
      <EmpoweringBusiness2 id="empowering2" />
      <ExpandingBusiness id="expanding" />
      <WhoTrust id="client" />
      <ContactUs id="contact" />

     
      <v-dialog v-model="dialog" width="280">
        <v-card>
          <v-card-text class="text-center" style="padding: 50px 35px">
            <div class="imgcomingsoon">
              
            </div>
            <div class="titelcomingsoon">
              COMING SOON
            </div>
            <div class="textcomingsoon">
              Kami sedang bekerja untuk menyediakan layanan tersebut.
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-main>

    <v-footer>
      <v-container>
        <v-row>
          <v-col class="text-left leftside" cols="12" xs="12" sm="4">
            <v-img alt="Fundtastic Logo" height="20" contain src="https://assets.invisee.com/statis/logo.png" transition="scale-transition" />
            <br>
            PT Nusantara Sejahtera Investama<br>
            Rukan Soho Manhattan.2<br>
            PIK 2, Kosambi Bar., Kec. Kosambi<br>
            Kabupaten Tangerang<br>
            Banten 15213 - Indonesia<br>
            <!-- PT Nusantara Sejahtera Investama<br>
            Treasury Tower Lantai 10<br>
            Unit Suite B District 8 Lot 28 - SCBD<br>
            Jend. Sudirman kav 52-53 No.5<br>
            Senayan - Kebayoran Baru<br>
            Jakarta 12190 - Indonesia<br> -->
            Customer Support : +62 81197006796<br>
            <!-- +62 21 5020 7773<br> -->
            info@fundtasticplus.co.id<br>

          </v-col>
          <!-- <v-col cols="12" xs="12" sm="4">
            <v-btn text @click="$vuetify.goTo('#product')" class="no-padding">
              Product
            </v-btn><br>
            <v-btn text @click="$vuetify.goTo('#client')" class="no-padding">
              Client
            </v-btn><br>
            <v-btn text @click="$vuetify.goTo('#contact')" class="no-padding">
              Contact </v-btn>
          </v-col> -->
          <v-col cols="12" xs="12" sm="8">
            <v-img contain src="https://assets.invisee.com/statis/iconfooter.jpg" transition="scale-transition" />
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-left copyright" style="">
            <span class="ptname">FUNDtastic+</span> dioperasikan oleh <b>PT Nusantara Sejahtera Investama</b> dan berperan sebagai Agen Penjual Reksa Dana (APERD) yang terdaftar dan diawasi oleh Otoritas Jasa Keuangan.<br><br>
            Seluruh produk investasi yang tersedia memiliki izin, terdaftar, dan diawasi oleh Otoritas Jasa Keuangan. Semua produk investasi terdapat risiko dan kemungkinan kerugian nilai. Data ditampilkan untuk bahan pertimbangan pengguna dalam memilih produk investasi. Data tersebut bersifat historis dan tidak menjanjikan nilai yang sama di masa mendatang. Produk yang tersedia tidak dikelola oleh FUNDtastic+.<br>
            FUNDtastic+ tidak bertanggung jawab atas risiko portofolio maupun kerugian investasi yang ditimbulkan dari pengelolaan Manajer Investasi.<br><br>
            Copyright © {{ new Date().getFullYear() }} FUNDtastic+ All Right reserved.
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
  </v-app>
</template>

<script>
  import HeaderImage from './components/HeaderImage';
  import ValueProporsition from './components/ValueProporsition';
  import SolvingProblem from './components/SolvingProblem';
  import EmpoweringCustomer from './components/EmpoweringCustomer';
  import EmpoweringBusiness2 from './components/EmpoweringBusiness2';
  import ExpandingBusiness from './components/ExpandingBusiness';
  import WhoTrust from './components/WhoTrust';
  import ContactUs from './components/ContactUs';

  export default {
    name: 'App',

    components: {
      HeaderImage,
      EmpoweringCustomer,
      ExpandingBusiness,
      WhoTrust,
      ContactUs,
      SolvingProblem,
      ValueProporsition,
      EmpoweringBusiness2,
    },
    data() {
      return {
        items: [{
            title: 'Product',
            anchor: '#product',
          },
          {
            title: 'Client',
            anchor: '#client',
          },
          {
            title: 'Contact',
            anchor: '#contact',
          },
        ],
        dialog: false,
      }
    },
    methods: {
      comingsoon() {
        this.dialog = true;
      }
    },
  };
</script>

<style>
  @import url('https://fonts.googleapis.com/css2?family=Ubuntu:ital,wght@0,400;0,500;0,700;1,400;1,500;1,700&display=swap');

  * {
    font-family: 'Ubuntu', sans-serif;
  }

  .line {
    /* background-color: #0082cc; */
    height: 4px;
    width: 100px;
    margin: 15px auto;
  }

  #product{
    background-color: rgba(248, 250, 250, 1);
    padding-top:30px;
  }

  /* #contact {
    background-color: #f6f6f6;
  } */

  #empowering{
    background-color: #ededed;
  }

  #value, #expanding, #client{
    padding-top: 70px;
  }

  #solving, #contact {
    padding-top: 70px;
    padding-bottom: 70px;
  }

  .theme--light.v-footer {
    background-color: #e7e7e7 !important;
  }

  .copyright {
    border-top: 1px solid #B0B0B0;
    margin:0 10px;
    padding: 15px 0 0;
    font-size: 12px;
  }
  
  .ptname{
    color: #0082CC;
    font-weight: bold;
  }

  .v-footer .leftside .v-image__image {
    background-position: left !important;
  }

  .no-padding {
    padding: 0 !important;
    justify-content: left;
  }

  .listitemmenu {
    cursor: pointer;
  }

  .col-content {
    text-align: center;
  }

  .marginauto {
    margin: auto;
  }

  .v-tabs-slider {
    background-color: #f6f6f6 !important;
    height: 0;
  }

  .titelcomingsoon{
    color: rgba(2, 97, 216, 1);
    font-weight: bold;
    padding: 10px 0;
  }

  .imgcomingsoon{
    background-image: url("https://assets.invisee.com/statis/revamp/comingsoon.png");
    background-position: center center;
    height: 136px;
    width: 100%;
  }

  .textcomingsoon{
    font-weight: bold;
    color: black;
    font-size: 13px;
  }
</style>